import React, { FunctionComponent } from "react";
import { Button as AntButton } from "antd";
import { ConfigProvider } from "@ui-kit/ConfigProvider";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";

import "./IconButton.css";

interface IconButtonProps {
  icon: React.ReactNode;
  onPress: React.MouseEventHandler<HTMLElement>;
  label?: string;
  disabled?: boolean;
  type?: "raised" | "flat";
  ref?: React.RefObject<HTMLButtonElement>;
}

const IconButton: FunctionComponent<IconButtonProps> = ({
  icon,
  onPress,
  label,
  disabled,
  type = "raised",
  ref,
}) => {
  return (
    <ConfigProvider
      type="client"
      themeConfigOverride={{
        components: {
          Button: {
            primaryColor: colors.neutral700,
            colorPrimaryActive: colors.neutral400,
            colorPrimary: colors.white,
            colorPrimaryHover: colors.neutral300,
            marginXS: 0,
            primaryShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
          },
        },
      }}>
      <AntButton
        className={`icon-button ${label && "round"}`}
        onClick={onPress}
        shape={label ? "round" : "circle"}
        type={type === "raised" ? "primary" : "text"}
        disabled={disabled}
        ref={ref}>
        {icon}
        {label && <span className="label">{label}</span>}
      </AntButton>
    </ConfigProvider>
  );
};

export { IconButton };
